// extracted by mini-css-extract-plugin
module.exports = {"profilePicture":"profilePicture_profilePicture__3hsB7"};